import { gql } from '@apollo/client'

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile(
    $firstName: String!
    $lastName: String!
    $email: String!
    $username: String!
  ) {
    updateUserProfile(
      firstName: $firstName
      lastName: $lastName
      email: $email
      username: $username
    ) {
      id
      username
      email
      firstName
      lastName
      slug
      profileComplete
    }
  }
`

export const BECOME_FUNDRAISER = gql`
  mutation becomeFundraiser($id: Int!, $avatar: Upload, $bio: String, $social: UserSocialInput) {
    becomeFundraiser(id: $id, avatar: $avatar, bio: $bio, social: $social) {
      id
      avatar {
        alt
        height
        width
        src
      }
    }
  }
`
